<template>
  <Container @focusout="isOpen = false" tabindex="0">
    <Title>{{ title }}</Title>
    <SelectedOption :last="last" @click="isOpen = !isOpen">{{ selectedOption }}</SelectedOption>
    <Options :open="isOpen">
      <Option
        v-if="isGlanceTable"
        @click="handleSelectOption(defaultOption)"
        :active="selectedOption === defaultOption"
        :isGlanceTable="isGlanceTable"
        >{{ defaultOption }}
      </Option>
      <Option
        v-for="option in options"
        :key="option"
        @click="handleSelectOption(option)"
        :isGlanceTable="isGlanceTable"
        :active="selectedOption === option"
        >{{ option }}
      </Option>
    </Options>
  </Container>
</template>

<script>
import { Container, Option, Options, Title, SelectedOption } from './dropdown.styles';

export default {
  components: { Container, Option, Options, Title, SelectedOption },
  props: {
    options: Array,
    title: String,
    last: Boolean,
    action: Function,
    selectedOption: String,
    isGlanceTable: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    defaultOption: function() {
      return `All ${this.title}`;
    },
  },
  methods: {
    handleSelectOption(option) {
      this.isOpen = !this.isOpen;

      this.action(option);
    },
  },
};
</script>
